import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityDK extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Tilgængelighedserklæring - CamAPS FX</title>
                    <meta name="title" content="Tilgængelighedserklæring"/>
                    <meta name="description"
                          content="CamDiab er forpligtet til at fremme og forbedre tilgængeligheden og brugervenligheden af sine digitale produkter for alle mennesker, herunder personer med handi"/>
                    <meta property="og:locale" content="da"/>
                    <meta name="keywords" content="tilgængelighedserklæring"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Tilgængelighedserklæring</h1>
                                <h3>Version dateret 11. september 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab er forpligtet til at fremme og forbedre tilgængeligheden og brugervenligheden af sine digitale produkter for alle mennesker, herunder personer med handicap.
                                </p>
                                <h2>
                                    Overensstemmelsesstatus
                                </h2>
                                <p>
                                    CamDiab bestræber sig på at opnå overensstemmelse med Retningslinjer for Tilgængeligt Webindhold (WCAG) version 2.2, niveau AA (WCAG 2.2 AA). Disse globalt anerkendte retningslinjer bidrager til at gøre webindhold mere tilgængeligt for alle.
                                </p>
                                <h2>
                                    Yderligere tiltag til støtte for tilgængelighed
                                </h2>
                                <p>
                                    CamDiab tager blandt andet følgende yderligere skridt for at gøre vores digitale indhold lettere at bruge:
                                </p>
                                <ul>
                                    <li>Tilbyde løbende undervisning i tilgængelighed til vores medarbejdere</li>
                                    <li>Anvende formelle metoder til kvalitetssikring af tilgængelighed gennem vurdering foretaget af tredjeparter</li>
                                    <li>Fastlægge klare mål og ansvarsområder for tilgængelighed</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Vi modtager gerne kommentarer til, hvordan vi kan forbedre vores digitale produkter for brugere med handicap. Hvis du har problemer med at se eller navigere i vores indhold, eller hvis du bemærker indhold, funktioner eller funktionalitet, som du mener ikke er fuldt tilgængelig for personer med handicap, bedes du kontakte os via vores support-e-mail: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Vi tager din feedback alvorligt og vil tage den i betragtning, når vi vurderer, hvordan vi bedst kan imødekomme alle vores kunders behov og udvikle vores overordnede tilgængelighedspolitikker. Selvom vi ikke har kontrol over indhold leveret af tredjepartsleverandører, opfordrer vi dem kraftigt til at levere indhold, der er tilgængeligt og brugervenligt.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
